<template>
  <div id="login">
    <div class="mask">
      <login-frame ref="loginFrame" />
    </div>
  </div>
</template>

<script>
import LoginFrame from './childComps/LoginFrame.vue';

export default {
  name: "Login",
  components: {
    LoginFrame
  },
  data() {
    return {

    }
  },
  mounted() {
    // 绑定enter事件
    // location.reload();
    this.enterKeyup();
  },
  destroyed() {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  methods: {
    /**
     * 逻辑区
     */
    enterKey(event) {
      const componentName = this.$options.name;
      if (componentName == "Login") {
        const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
        console.log(code);
        if (code == 13) {
          this.$refs.loginFrame.handleLoginClick('loginFrom');
        }
      }
    },
    enterKeyupDestroyed() {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup() {
      document.addEventListener("keyup", this.enterKey);
    },



  }
}
</script>

<style lang='scss' scoped>
  #login {
    width: 100vw;
    height: 100vh;
    background: url("../../assets/image/login/loginBgImg.png") repeat fixed;
    background-color: rgba($color:#2e2e2e, $alpha: .29);
    .mask {
      width: 100%;
      height: 100%;
      background-color: rgba($color:#2e2e2e, $alpha: .29);
      position: relative;
    }
  }
</style>
